<template>
  <div class="pin-wrap">
    <div class="pin-top" :style="{height: topHeight, 'z-index': topIndex}">
      <slot name="top"></slot>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'TnLayout',
  props: {
    topHeight: {
      type: String,
      default: '80px'
    },
    topIndex: {
      type: Number,
      default: 0
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/TnLayout.vue